import { useState } from 'react';
import Stack from '@mui/material/Stack';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';;
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';

export default function MultiVariableSelect(props) {
  const { userParams, setUserParams, productVariableChoices=null } = props;
  const defaultVariableChoices = [
    {value: 'clds',   label: 'Cloud Conditions',},
    {value: 'vis',    label: 'Visibility',},
    {value: 'wx',     label: 'Present Weather',},
    {value: 'temp',   label: 'Temperature'},
    {value: 'wetb',   label: 'Wet Bulb Temperature',},
    {value: 'dwpt',   label: 'Dewpoint',},
    {value: 'rhum',   label: 'Relative Humidity',},
    {value: 'wspd',   label: 'Wind Speed',},
    {value: 'wdir',   label: 'Wind Direction',},
    {value: 'wgust',  label: 'Wind Gust',},
    {value: 'pres',   label: 'Station Pressure',},
    {value: 'slp',    label: 'Sea Level Pressure',},
    {value: 'pcpn',   label: 'Precipitation',},
    {value: 'altp',   label: 'Altimeter Setting',},
//    {value: 'wchill', label: 'Wind Chill',},
//    {value: 'htindx', label: 'Heat Index',},
  ]

  const variableChoices = productVariableChoices ? productVariableChoices : defaultVariableChoices;
  const itemsPerColumn = Math.round((variableChoices.length / 2), 0)

  // local input storage structure
  const initialVarsMap = new Map(variableChoices.map(item => [item.value, userParams.variables.indexOf(item.value) >= 0]));
  const [ varsMap, setVarsMap ] = useState(initialVarsMap);
  
  const handleCheckboxChange = (event) => {
    const name = event.target.name;
	const checked = event.target.checked;
    // update local map
    const newMap = new Map(varsMap);
    newMap.set(name, checked);
    setVarsMap(newMap);
    // update userParams
    const newVariables = variableChoices.filter(v => newMap.get(v.value)).map(v => v.value)
    setUserParams({...userParams, variables: newVariables})
  }

  // put up a column of checkboxes
  const checkboxes = (opt) => {
    return (
        <FormControlLabel
            key={opt.value}
            control={
                <Checkbox 
                    checked={varsMap.get(opt.value)} 
                    name={opt.value} 
                    sx={{ py: 0 }} 
                    onChange={handleCheckboxChange}
                />
            }
            label={opt.label}
        />     
    )
  }

  return (
    <>
        <FieldsetBox component="fieldset" sx={{ mt: 1 }}>
            <LegendStyled>Select variables</LegendStyled>
            <Stack direction="row" spacing={3}>
                <FormGroup>
                    { variableChoices.slice(0, itemsPerColumn).map((opt) => (
                       checkboxes(opt)
                    ))}
                </FormGroup>
                <FormGroup>
                    { variableChoices.slice(itemsPerColumn).map((opt) => (
                        checkboxes(opt)
                    ))}
                </FormGroup>
            </Stack>
        </FieldsetBox>
    </>
  )
}
